import { createRef, useEffect, useReducer, useState } from "react"
import { GridList, InputAdornment, Paper, TextField, Typography } from "@material-ui/core"
import { useHistory } from "react-router-dom";
import Loader from 'react-loader-spinner'
import api from "../api";
import filterIcon from '../../assets/ic_search@3x.png';
import search from '../../assets/search.png';
import CloseImage from '../../assets/ic_close.png';
import ProfileImage from '../../assets/profile.png';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { format } from 'date-fns';


export default function SHSDokter(props) {
    const history = useHistory();
    const wrapperRef = createRef()
    const [dataTable, setDatatable] = useState([])
    const [visiblePopup, setVisiblePopup] = useState(false)
    const [visibleForce, setVisibleForce] = useState(false)
    const [visibleLate, setVisibleLate] = useState(false)
    const [visibleHold, setVisibleHold] = useState(false)
    const [lateDoctorID, setLateDoctorID] = useState(null)
    const [holdDoctorID, setHoldDoctorID] = useState(null)
    const [scheduleID, setDoctorScheduleID] = useState(null)
    const [loading, setLoading] = useState(false)
    const [selectedAction, setSelectedAction] = useState("")
    const [textForce, setTextForce] = useState("")
    const [index, setIndex] = useState("");
    const [indexHold, setIndexHold] = useState("");
    const [holdMessage, setHoldMessage] = useState(null);
    const [delay, setDelay] = useState("");
    const [open, setOpen] = useState(true);
    const [name, setName] = useState("");
    const [poli, setListPoli] = useState([])
    const [poliklinik, setPoliklinik] = useState(null)
    const [detailDokter, setDetailDokter] = useState(null)
    const [create, setCreate] = useState(false);
    const [read, setRead] = useState(false);
    const [update, setUpdate] = useState(false);
    const [deleted, setDeleted] = useState(false);

    useEffect(() => {
        props.setShowNotif(true)
        getPermission(props)
        getListDataDokter()
        getDataPoli()
    }, [])
    // console.log(dataTable);
    // console.log(delay);
    // console.log(index);

    const handleClick = () => {
        const wrapper = wrapperRef.current;
        // console.log(wrapper.classList);
        wrapper.classList.toggle('is-nav-open')
        setOpen(!open)
    }

    const getPermission = (e) => {
        api.create().getPermission(e.menuid).then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = response.data.data
                    setCreate(data.create)
                    setUpdate(data.update)
                    setRead(data.read)
                    setDeleted(data.delete)
                }
            }
        })
    }

    const getDataPoli = (value) => {
        if (value === undefined || value === "") {
            api.create().getListPoli(value === undefined ? "" : value).then(response => {
                console.log(response)
                if (response.data) {
                    let listPoli = []
                    response.data.data.map((item, index) => {
                        listPoli.push({
                            id: item.id,
                            name: String(item.name).trim()
                        })
                    })
                    setListPoli(listPoli)
                }
            })
        }
    }

    const forceUpdate = useReducer(bool => !bool)[1];

    const getListDataDokter = () => {
        api.create().getListDokterPemanggilan().then(response => {
            console.log(response);
            if (response.data) {
                if (response.data.status === true) {
                    let data = []
                    response.data.data.map((item, index) => {
                        if (item.session.length > 0) {
                            item.session.map(val => {
                                data.push({
                                    name: item.name,
                                    desc: item.desc,
                                    polyclinic_name: item.polyclinic_name,
                                    img: item.media_path,
                                    doctor_id: item.id,
                                    doctor_schedule_id: val.doctor_schedule_id,
                                    status: val.session_status,
                                    time_start: val.time_start,
                                    time_end: val.time_end,
                                    late_time: val.late_time,
                                    hold_reason: val.hold_reason,
                                    id: item.id,
                                    schedule_date: item.schedule_date
                                })
                            })
                        }
                    })
                    setDatatable(data)
                }
            }
        })
    }

    const handleFilter = (nama) => {
        console.log(poliklinik);
        if (poliklinik === null || poliklinik.length < 1) {
            api.create().getDokterByKeyword(nama === undefined || nama === null ? name : nama).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        let data = []
                        response.data.data.map((item, index) => {
                            if (item.session.length > 0) {
                                item.session.map(val => {
                                    data.push({
                                        name: item.name,
                                        desc: item.desc,
                                        polyclinic_name: item.polyclinic_name,
                                        img: item.media_path,
                                        doctor_id: item.id,
                                        doctor_schedule_id: val.doctor_schedule_id,
                                        status: val.session_status,
                                        time_start: val.time_start,
                                        time_end: val.time_end,
                                        late_time: val.late_time,
                                        hold_reason: val.hold_reason,
                                        id: item.id,
                                        schedule_date: item.schedule_date
                                    })
                                })
                            }
                        })
                        setDatatable(data)
                    }
                }
            })
        } else {
            let id = []
            poliklinik.map((item) => {
                id.push(item.id)
            })
            api.create().getDokterByKeywordAndPoli(nama === undefined || nama === null ? name : nama, id).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        let data = []
                        response.data.data.map((item, index) => {
                            if (item.session.length > 0) {
                                item.session.map(val => {
                                    data.push({
                                        name: item.name,
                                        desc: item.desc,
                                        polyclinic_name: item.polyclinic_name,
                                        img: item.media_path,
                                        doctor_id: item.id,
                                        doctor_schedule_id: val.doctor_schedule_id,
                                        status: val.session_status,
                                        time_start: val.time_start,
                                        time_end: val.time_end,
                                        late_time: val.late_time,
                                        hold_reason: val.hold_reason,
                                        id: item.id,
                                        schedule_date: item.schedule_date
                                    })
                                })
                            }
                        })
                        setDatatable(data)
                    }
                }
            })
        }
    }

    const updateSession = (id, status, delay, holdMessage) => {
        console.log(delay);
        setLoading(true)
        let payload = {
            "doctor_schedule_id": id,
            "status": status,
            "late_time": +delay,
            "hold_reason": holdMessage,
        }
        console.log(payload);
        api.create().updateSessionDokter(payload).then(response => {
            console.log(response);
            setLoading(true)
            if (response.data) {
                if (response.data.status === true) {
                    if (name !== "") {
                        handleFilter(name)
                    } else {
                        getListDataDokter()
                    }
                    setVisiblePopup(false)
                } else {
                    if (response.data.data) {
                        setDetailDokter(id)
                        setTextForce(response.data.data)
                        setVisibleForce(true)
                        forceUpdate()
                    }
                }
                setLoading(false)
            }
        })
    }

    const updateSessionForce = (id, status, delay, holdMessage) => {
        console.log(delay, id);
        setLoading(true)
        let payload = {
            "doctor_schedule_id": detailDokter,
            "status": status,
            "force_update": true
        }
        console.log(payload);
        api.create().updateSessionDokter(payload).then(response => {
            console.log(response);
            setLoading(true)
            if (response.data) {
                if (response.data.status === true) {
                    setLoading(false)
                    if (name !== "") {
                        handleFilter(name)
                    } else {
                        getListDataDokter()
                    }
                    setVisiblePopup(false)
                    setVisibleForce(false)
                } else {
                    if (response.data.data) {

                    }
                }
            }
        })
    }

    // console.log(holdMessage);
    const listReasonHold = [
        { name: "Dokter tindakan" },
        { name: "Dokter istirahat" },
    ]

    const doSubmit = () => {
        updateSession(lateDoctorID, 4, delay)
        setVisibleLate(false)
    }

    const doHold = () => {
        // setLoading(true)
        updateSession(holdDoctorID, 2, null, holdMessage !== null ? holdMessage.name : "")
        setVisibleHold(false)
    }

    const loadingComponent = (
        <div style={{ position: 'fixed', zIndex: 110, top: 0, left: 0, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'rgba(255,255,255,0.8)' }}>
            <Loader
                type="Puff"
                color="#2a9c6c"
                height={100}
                width={100}
            />
        </div>
    );

    return (
        <div style={{}}>
            {loading ? loadingComponent : null}
            {read && (
                <div style={{ padding: 20, maxHeight: props.height - 90, overflow: 'auto' }}>
                    <div style={{ display: 'flex' }}>
                        <TextField
                            style={{ minWidth: 200, marginRight: 20 }}
                            label="Nama Dokter"
                            onChange={(e) => {
                                setName(e.target.value)
                                // handleFilter(e.target.value)
                                // forceUpdate()
                            }}
                            inputProps={{
                                style: {

                                }
                            }}
                            InputLabelProps={{
                                style: {
                                    color: '#7e8085',
                                }
                            }}
                        />
                        <Autocomplete
                            multiple
                            options={poli}
                            getOptionLabel={(option) => option.name}
                            style={{ minWidth: 200, marginTop: '4px', marginRight: 20 }}
                            name='poliklinik'
                            id="tipe"
                            onChange={(event, newInputValue) => {
                                setPoliklinik(newInputValue)
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Klinik"
                                />
                            }
                        />
                        <div style={{ width: 200, alignSelf: 'center' }}>
                            <button
                                style={{ outline: 'none', borderColor: 'transparent', backgroundColor: '#3bbf50', borderRadius: 20, cursor: 'pointer', padding: '0px 20px', height: 35, marginLeft: 10 }}
                                onClick={() => {
                                    handleFilter(name)
                                    forceUpdate()
                                }}
                            >
                                <Typography style={{ color: 'white' }}>Filter</Typography>
                            </button>

                        </div>
                        {/* <div onClick={() => handleClick()} style={{ height: 32, width: 40, backgroundColor: 'white', borderRadius: 20, marginRight: 10, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                        <img
                            style={{ margin: 'auto', width: 20, marginLeft: 10, marginTop: 5 }} src={filterIcon} />
                    </div> */}
                    </div>
                    <div style={{ margin: 'auto' }}>
                        <GridList cellHeight={240} cols={4} style={{ justifyContent: dataTable.length % 2 === 0 ? 'flex-start' : 'space-between' }} spacing={'5%'}>
                            {dataTable.map((item, index) => (
                                <Paper style={{ display: 'grid', height: 220, borderRadius: 20, boxShadow: '5px 5px 10px 0 #999999', margin: 10, padding: 10, width: 450 }}>
                                    <div style={{ display: 'flex', width: '100%' }}>
                                        <img src={item.img === null ? ProfileImage : item.img} style={{ width: 60, height: 60, borderRadius: 30 }} />
                                        {/* <div style={{ backgroundColor: 'green', width: 60, height: 60, borderRadius: 30 }} /> */}
                                        <div style={{ marginLeft: 20 }}>
                                            <Typography style={{ fontWeight: 'bold' }}>{item.name}</Typography>
                                            <div style={{ marginTop: 5, marginBottom: 5 }}>
                                                <TextField
                                                    multiline={true}
                                                    rowsMax={2}
                                                    style={{ width: '100%', fontWeight: '500' }}
                                                    InputProps={{ disableUnderline: true, style: { color: 'black', fontSize: 12, fontWeight: '500' } }}
                                                    value={item.polyclinic_name}
                                                />
                                                <Typography style={{ fontWeight: '500', color: item.status === "START" ? 'green' : item.status === 'LATE' || item.status === 'HOLD' ? '#ffa654' : item.status === '-' ? 'black' : 'red', fontSize: 12, fontWeight: '500' }}>{item.status === "LATE" ? `Late about ${item.late_time ? item.late_time : null} minutes` : item.status === "HOLD" ? `${item.status} - ${item.hold_reason}` : item.status}</Typography>
                                                <Typography style={{ fontFamily: 'Poppins', color: 'black', fontSize: 11, marginTop: 1 }}>Tanggal : {item.schedule_date ? format(new Date(item.schedule_date), 'dd MMM yyyy') : "-"}</Typography>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ display: 'flex', padding: '0px 2% 0px 2%' }}>
                                        <div style={{ width: '50%' }}>
                                            <Typography style={{ color: '#bdc3c7' }}>Jam Mulai Praktek</Typography>
                                            <Typography style={{ color: 'black', fontWeight: 'bold' }}>{item.time_start}</Typography>
                                        </div>
                                        <div style={{ width: '50%' }}>
                                            <Typography style={{ color: '#bdc3c7' }}>Jam Selesai Praktek</Typography>
                                            <Typography style={{ color: 'black', fontWeight: 'bold' }}>{item.time_end}</Typography>
                                        </div>
                                    </div>
                                    {
                                        item.status === "HOLD" && create && update ?
                                            <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '0px 3% 0px 3%', borderTopColor: '#ebebeb', borderTopStyle: 'solid', borderTopWidth: 1, }}>
                                                <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', cursor: 'default' }}
                                                >
                                                    <Typography style={{ color: '#3bbf50', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Mulai Sesi</Typography>
                                                </div>
                                                <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setSelectedAction("Berhenti")
                                                        updateSession(item.doctor_schedule_id, 1)
                                                        setDetailDokter(item.doctor_schedule_id)
                                                    }}>
                                                    <Typography style={{ color: '#ffa654', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Lanjut Sesi</Typography>
                                                </div>
                                                <div style={{ width: '33%', alignSelf: 'center', cursor: 'pointer' }}
                                                    onClick={() => {
                                                        setVisiblePopup(true)
                                                        setDetailDokter(item.doctor_schedule_id)
                                                    }}>
                                                    <Typography style={{ color: '#ff5b5b', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Berhenti</Typography>
                                                </div>
                                            </div>
                                            : item.status === "START" && create && update ?
                                                <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '0px 3% 0px 3%', borderTopColor: '#ebebeb', borderTopStyle: 'solid', borderTopWidth: 1, }}>
                                                    <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', cursor: 'default' }}
                                                    >
                                                        <Typography style={{ color: '#3bbf50', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Mulai Sesi</Typography>
                                                    </div>
                                                    <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', cursor: 'pointer' }}
                                                        onClick={() => {
                                                            setSelectedAction("Berhenti")
                                                            setVisibleHold(true)
                                                            setIndexHold(index)
                                                            setHoldDoctorID(item.doctor_schedule_id)
                                                            forceUpdate()
                                                            // setLoading(true)
                                                            // updateSession(item.doctor_schedule_id, 2)
                                                        }}>
                                                        <Typography style={{ color: '#ffa654', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Tunda Sesi</Typography>
                                                    </div>
                                                    <div style={{ width: '33%', alignSelf: 'center', cursor: 'pointer' }}
                                                        onClick={() => {
                                                            setVisiblePopup(true)
                                                            setDetailDokter(item.doctor_schedule_id)
                                                            forceUpdate()
                                                        }}>
                                                        <Typography style={{ color: '#ff5b5b', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Berhenti</Typography>
                                                    </div>
                                                </div>
                                                :
                                                item.status === "STOP" && create && update ?
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '0px 3% 0px 3%', borderTopColor: '#ebebeb', borderTopStyle: 'solid', borderTopWidth: 1, }}>
                                                        <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', cursor: 'default' }}
                                                        >
                                                            <Typography style={{ color: '#3bbf50', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Mulai Sesi</Typography>
                                                        </div>
                                                        <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', cursor: 'default' }}
                                                        >
                                                            <Typography style={{ color: '#ffa654', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Lanjut Sesi</Typography>
                                                        </div>
                                                        <div style={{ width: '33%', alignSelf: 'center', cursor: 'default' }}
                                                        >
                                                            <Typography style={{ color: '#ff5b5b', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Berhenti</Typography>
                                                        </div>
                                                    </div>
                                                    :
                                                    create && update && (

                                                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', padding: '0px 3% 0px 3%', borderTopColor: '#ebebeb', borderTopStyle: 'solid', borderTopWidth: 1, }}>
                                                            <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setSelectedAction(index)
                                                                    updateSession(item.doctor_schedule_id, 1)
                                                                    setDoctorScheduleID(item.doctor_schedule_id)
                                                                    forceUpdate()
                                                                }}>
                                                                <Typography style={{ color: '#3bbf50', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Mulai Sesi</Typography>
                                                            </div>
                                                            <div style={{ width: '33%', borderRightColor: '#ebebeb', borderRightStyle: 'solid', borderRightWidth: 1, alignSelf: 'center', cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setSelectedAction("Terlambat")
                                                                    setVisibleLate(true)
                                                                    setIndex(index)
                                                                    setLateDoctorID(item.doctor_schedule_id)
                                                                    // updateSession(item.doctor_schedule_id, 4)
                                                                }}>
                                                                <Typography style={{ color: '#ffa654', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Terlambat</Typography>
                                                            </div>
                                                            <div style={{ width: '33%', alignSelf: 'center', cursor: 'default' }}
                                                            // onClick={() => {
                                                            //     setSelectedAction("Terlambat")
                                                            //     updateSession(item.doctor_schedule_id, 3)
                                                            // }}
                                                            >
                                                                <Typography style={{ color: '#ff5b5b', fontWeight: '500', fontFamily: 'Poppins', textAlign: 'center' }}>Berhenti</Typography>
                                                            </div>
                                                        </div>
                                                    )

                                    }
                                </Paper>

                            ))}
                        </GridList>
                    </div>

                    {/* <div className={"wrapper"} ref={wrapperRef} style={{ width: 455, height: props.height, position: 'absolute', marginRight: !open ? -400 : -455, top: 0, zIndex: 1 }}>
                    <div className={"nav__body"} style={{ backgroundColor: 'white', height: '100%', width: '100%' }}>
                        <div className="" style={{ height: 64, backgroundColor: '#278863', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span style={{ color: 'white', fontSize: 18, marginLeft: 40 }}>Filter</span>
                            <button
                                type="button"
                                className="btn btn-circle btn-white"
                                onClick={() => handleClick()}
                                style={{ marginRight: 20 }}
                            >
                                <img src={CloseImage} style={{ width: 20, height: 20 }} />
                            </button>
                        </div>
                        <div style={{ marginTop: 20, paddingLeft: 30, paddingRight: 30 }}>
                            <TextField
                                style={{ width: '100%', marginTop: 7 }}
                                id="nama"
                                name="nama"
                                label="Nama Dokter"
                                placeholder={"input Nama Dokter"}
                                onChange={(e) => {
                                    setName(e.target.value)
                                    forceUpdate()
                                }}
                                inputProps={{
                                    style: {
                                    }
                                }}
                                InputLabelProps={{
                                    style: {

                                        color: '#7e8085',
                                    }
                                }}
                            />
                            <Autocomplete
                                multiple
                                options={poli}
                                getOptionLabel={(option) => option.name}
                                style={{ marginTop: 20, width: '100%' }}
                                name='poliklinik'
                                id="tipe"
                                onChange={(event, newInputValue) => {
                                    setPoliklinik(newInputValue)
                                }}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                        InputLabelProps={{ style: { color: '#7e8085' } }}
                                        label="Klinik"
                                    />
                                }
                            />
                        </div>

                        <div style={{ marginTop: 60, display: 'flex', justifyContent: 'center' }}>
                            <button
                                onClick={(e) => handleFilter()}
                                style={{ outline: 'none', height: 39, width: 269, borderRadius: 20, boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)', backgroundColor: '#278863', borderColor: 'transparent', cursor: 'pointer' }}>
                                <Typography style={{ textAlign: 'center', color: 'white' }}>Submit</Typography>
                            </button>
                        </div>
                    </div>
                </div> */}

                    {
                        visibleLate ?
                            <div className="App app-popup-show background-transparent">
                                <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                                    <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                        <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                            <div className="popup-title">
                                                <span style={{ color: 'black', fontSize: 18, }}>Dokter Terlambat </span>
                                            </div>
                                        </div>
                                        <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                            <button
                                                type="button"
                                                className="btn btn-circle btn-white"
                                                onClick={() => setVisibleLate(false)}
                                            >
                                                <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                            </button>
                                        </div>
                                    </div>

                                    <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                                        <div className="column-1">
                                            <div className="">
                                                <TextField
                                                    style={{ width: '100%', marginTop: 15 }}
                                                    id="time"
                                                    name="time"
                                                    label="Estimasi Terlambat (menit)"
                                                    placeholder={"keterlambatan (menit)"}
                                                    type="number"
                                                    value={delay}
                                                    onChange={(e) => {
                                                        setDelay(e.target.value)
                                                        dataTable[index].late_time = e.target.value
                                                    }}
                                                    inputProps={{ min: 0 }}
                                                    InputProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            width: '58%'
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#7e8085',
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                        <div className="column-1" style={{ alignSelf: 'center' }}>
                                        </div>
                                        <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            <div
                                                onClick={() => setVisibleLate(false)}
                                                style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                                <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    doSubmit()
                                                }}
                                                style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                    {
                        visibleHold ?
                            <div className="App app-popup-show background-transparent">
                                <div className="popup-content background-white" style={{ borderRadius: 8, backgroundColor: 'white' }}>
                                    <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                                        <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                                            <div className="popup-title">
                                                <span style={{ color: 'black', fontSize: 18, }}>Tunda Jadwal Dokter </span>
                                            </div>
                                        </div>
                                        <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                                            <button
                                                type="button"
                                                className="btn btn-circle btn-white"
                                                onClick={() => setVisibleHold(false)}
                                            >
                                                <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                            </button>
                                        </div>
                                    </div>

                                    <div className="grid" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                                        <div className="column-1">
                                            <div className="">
                                                <Autocomplete
                                                    // multiple
                                                    options={listReasonHold}
                                                    getOptionLabel={(option) => option.name}
                                                    debug
                                                    name='Alasan Ditunda'
                                                    id="tipe"
                                                    onChange={(event, newInputValue) => {
                                                        setHoldMessage(newInputValue)
                                                    }}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                                            InputLabelProps={{ style: { color: '#7e8085' } }}
                                                            label="Alasan Ditunda"
                                                        />
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                                        <div className="column-1" style={{ alignSelf: 'center' }}>
                                        </div>
                                        <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            <div
                                                onClick={() => setVisibleHold(false)}
                                                style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                                <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    doHold()
                                                }}
                                                style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                                <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : null
                    }
                </div>
            )}
            {visiblePopup && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 520 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisiblePopup(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 20 }}>Anda yakin ingin stop sesi dokter tersebut ?. <br /> <span><b>Anda tidak dapat memulai sesi kembali jika sesi sudah diberhentikan dihari yang sama.</b> </span></Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisiblePopup(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => {
                                        updateSession(detailDokter, 3)
                                    }}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleForce && (
                <div className="App app-popup-show">
                    <div className="popup-content-middle background-white" style={{ borderRadius: 8, width: 500 }}>
                        <div className="popup-panel grid grid-2x" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                            <div className="col-1" />
                            <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center', padding: 0 }}>
                                <button
                                    type="button"
                                    className="btn btn-circle btn-white"
                                    onClick={() => setVisibleForce(false)}
                                >
                                    <img src={CloseImage} style={{ width: 20, height: 20 }} />
                                </button>
                            </div>
                        </div>
                        <div style={{ padding: 20 }}>
                            <Typography style={{ textAlign: 'left', fontSize: 16 }}>{textForce}</Typography>
                        </div>
                        <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                            <div className="column-1" style={{ alignSelf: 'center' }}>
                            </div>
                            <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <div
                                    onClick={() => setVisibleForce(false)}
                                    style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                                    <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                                </div>
                                <div
                                    onClick={() => {
                                        updateSessionForce(detailDokter, 1)
                                    }}
                                    style={{ height: 32, width: 150, backgroundColor: '#ff4252', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                                    <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Konfirmasi</Typography>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}